import React from "react";

/* eslint-disable max-len */
export default function CheckboxCheckedIcon() {
	return (
		<svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 30.62 30.56" enableBackground="new 0 0 30.62 30.56" xmlSpace="preserve">
			<path fill="none" stroke="#D1161B" strokeWidth="3" strokeMiterlimit="10" d="M25.91,28.88H4.66c-1.66,0-3-1.34-3-3V4.63
	c0-1.66,1.34-3,3-3h21.25c1.66,0,3,1.34,3,3v21.25C28.91,27.54,27.57,28.88,25.91,28.88z"/>
			<path fill="#D1161B" d="M21.95,24.7H8.62c-1.54,0-2.79-1.25-2.79-2.79V8.59c0-1.54,1.25-2.79,2.79-2.79h13.32
	c1.54,0,2.79,1.25,2.79,2.79v13.32C24.73,23.45,23.49,24.7,21.95,24.7z"/>
		</svg>
	);
}
